import store from 'store/index' ///导入公共仓库

////配置正常加载的页面
// import Login from 'views/beforeLogin/LoginPage.vue'
const Login = () => import('views/beforeLogin/LoginPage.vue') //登录页  懒加载的

// import Register from 'views/beforeLogin/RegisterPage.vue'

////配置导入懒加载页面  登录之前页面
const Register = () => import('views/beforeLogin/RegisterPage.vue') //注册页面
const FirstEntry = () => import('views/afterLogin/config/firstEntry.vue') //
const MChangePassword = () => import('views/beforeLogin/MChangePassword.vue') //修改密码页面
const configServerIP = () => import('views/beforeLogin/configServerIP.vue')
const yanShiPage = () => import('views/beforeLogin/yanShiPage.vue')

const privacyPolicy = () => import('views/beforeLogin/privacyPolicy.vue') //隐私政策URL
const ServiceAgreement = () => import('views/beforeLogin/ServiceAgreement.vue') //用户服务协议URL
//控制页面
const ControlPage = () => import('views/afterLogin/control/controlPage.vue') //控制主页面
//控制页面的下级路由
const Home = () => import('views/afterLogin/control/home.vue')
const Region = () => import('views/afterLogin/control/region.vue')
const Message = () => import('views/afterLogin/control/message.vue')
const HomeChangeScene = () =>
  import('views/afterLogin/control/homeChangeScene.vue')
const HomeChangeDevice = () =>
  import('views/afterLogin/control/homeChangeDevice.vue')

// const MainTabBar = ()=>import('../components/content/maintabbar/MainTabBar.vue')
//区域管理页面
const RegionManage = () => import('views/afterLogin/config/regionManage.vue')
///分享管理页面
const shareManage = () => import('views/afterLogin/config/shareManage.vue')

///背景管理页面
const backgroundManage = () =>
  import('views/afterLogin/config/backgroundManage.vue')

//设置管理页面
const ConfigMainPage = () =>
  import('views/afterLogin/config/configMainPage.vue')
////场景管理页面
const ConfigSceneMain = () =>
  import('views/afterLogin/config/configScenePage/confiSceneMain.vue')
const ConfigSceneManage = () =>
  import('views/afterLogin/config/configScenePage/configSceneManage.vue')
const ConfigAddScene = () =>
  import('views/afterLogin/config/configScenePage/configAddScene.vue')
const ConfigAddSceneRule = () =>
  import('views/afterLogin/config/configScenePage/configAddSceneRule.vue')
const ConfigSelectSceneObject = () =>
  import('views/afterLogin/config/configScenePage/configSelectSceneObject.vue')
const ConfigSelectSceneObjectRegion = () =>
  import(
    'views/afterLogin/config/configScenePage/configSelectSceneObjectRegion.vue'
  )


///组管理页面  //代号 20231207-1
const ConfigGroupMain = () =>
  import('views/afterLogin/config/configGroupPage/confiGroupMain.vue')
const ConfigGroupManage = () =>
  import('views/afterLogin/config/configGroupPage/configGroupManage.vue')
const ConfigAddGroup = () =>
  import('views/afterLogin/config/configGroupPage/configAddGroup.vue')
const ConfigAddGroupRule = () =>
  import('views/afterLogin/config/configGroupPage/configAddGroupRule.vue')
const ConfigSelectGroupObject = () =>
  import('views/afterLogin/config/configGroupPage/configSelectGroupObject.vue')
const ConfigSelectGroupObjectRegion = () =>
  import(
    'views/afterLogin/config/configGroupPage/configSelectGroupObjectRegion.vue'
  )


///区域选择和图片选择独立页面 //新增组类型页面
const SelectRegion = () => import('views/afterLogin/config/selectRegion.vue')
const SelectIcon = () => import('views/afterLogin/config/selectIcon.vue')
// 代号 20231207-1  组功能实现
const selectGroupControlType = () => import('views/afterLogin/config/selectGroupControlType.vue')



////账号管理页面
const AccountNumberMain = () =>
  import('views/afterLogin/config/accountNumberPage/accountNumberMain.vue')
const AccountNumberManage = () =>
  import('views/afterLogin/config/accountNumberPage/accountNumberManage.vue')
const AddSonAccountNumber = () =>
  import('views/afterLogin/config/accountNumberPage/addSonAccountNumber.vue')
const SonAccountSelectRegion = () =>
  import('views/afterLogin/config/accountNumberPage/sonAccountSelectRegion.vue')
const AccountNumberInfoManage = () =>
  import(
    'views/afterLogin/config/accountNumberPage/accountNumberInfoManage.vue'
  )
const ChangePassWord = () =>
  import('views/afterLogin/config/accountNumberPage/changePassWord.vue')
const ChangePhoneNumber = () =>
  import('views/afterLogin/config/accountNumberPage/changePhoneNumber.vue')
const changeSonPassWord = () =>
  import('views/afterLogin/config/accountNumberPage/changeSonPassWord.vue')

///设备管理的页面
const DeviceManageMain = () =>
  import('views/afterLogin/config/deviceManagePage/deviceManageMain.vue')
const DeviceManage = () =>
  import('views/afterLogin/config/deviceManagePage/deviceManage.vue')
//设备管理的页面 下的主机管理页面
const hostManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/hostManagePage/hostManage.vue'
  )
const autoSearchHost = () =>
  import(
    'views/afterLogin/config/deviceManagePage/hostManagePage/autoSearchHost.vue'
  )
const addChangeHost = () =>
  import(
    'views/afterLogin/config/deviceManagePage/hostManagePage/addChangeHost.vue'
  )
const handAddHost = () =>
  import(
    'views/afterLogin/config/deviceManagePage/hostManagePage/handAddHost.vue'
  )
const replaceHost = () =>
  import(
    'views/afterLogin/config/deviceManagePage/hostManagePage/replaceHost.vue'
  )
////设备管理页面下的  设备上线设置
const selectDeviceHost = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/selectDeviceHost.vue'
  )
const deviceGoOnlineManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/deviceGoOnlineManage.vue'
  )
const addNewDevice = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/addNewDevice.vue'
  )
// 代号 20241212-1
const threadDeviceGoOnlineManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadDeviceGoOnlineManage.vue'
  )
const threadAddNewDevice = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadAddNewDevice.vue'
  )
const threadNetworkManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadNetworkManage.vue'
  )
const threadNetworkNewStart = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadNetworkNewStart.vue'
  )
const threadDeviceNetIn = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadDeviceNetIn.vue'
  )

const threadDeviceReplace = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadDeviceReplace.vue'
  )
const threadDeviceManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadDeviceManage.vue'
  )
const device485Manage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/device485Manage.vue'
  )
const productConfigResend = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/productConfigResend.vue'
  )
const productSceneResend = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/productSceneResend.vue'
  )
const panelExtensionManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/panelExtensionManage.vue'
  )
const addThirdPanel = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/addThirdPanel.vue'
  )
const thirdPanelDeviceManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/thirdPanelDeviceManage.vue'
  )
const thirdPanelInfoManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/thirdPanelInfoManage.vue'
  )
const threadGatewayManage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/threadGatewayManage.vue'
  )
const Gateway485Manage = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceGoOnlinePage/Gateway485Manage.vue'
  )

////设备管理页面下的   设备列表下面的 公共页面
const deviceTypeList = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/deviceTypeList.vue'
  )
const deviceList = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/deviceList.vue'
  )
const deviceDetails = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/deviceDetails.vue'
  )
//代号20220921-1
const configDevice = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/configDevice.vue'
  )
// 代号 20241212-1
const configDeviceList = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/configDeviceList.vue'
  )
const deviceObjectDetails = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/deviceObjectDetails.vue'
  )

////设备管理页面下的   设备列表 下面的单独页面
const selectBindingObject = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/selectBindingObject.vue'
  )
const timeConfig022Page = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/timeConfig022Page.vue'
  )
const cycleConfig022Page = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/cycleConfig022Page.vue'
  )
const selectOneScene = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/selectOneScene.vue'
  )

const cycleTask027Config = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/cycleTask027Config.vue'
  )
const addCycTask027Page = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/addCycTask027Page.vue'
  )
const changeLoopTask = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/changeLoopTask.vue'
  )
const selectLoopNum = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/selectLoopNum.vue'
  )
const select03ControlType = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/select03ControlType.vue'
  )
const select03ControlObject = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/select03ControlObject.vue'
  )
const config019Page = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/config019Page.vue'
  )
const config023Page = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/config023Page.vue'
  )
const select05ControlObjectState = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/select05ControlObjectState.vue'
  )
const HistoricalElectricity027Page = () =>
  import(
    'views/afterLogin/config/deviceManagePage/deviceListPage/otherConfigPage/HistoricalElectricity027Page.vue'
  )

////关于页面
const aboutPage = () => import('views/afterLogin/config/aboutPage.vue')

const mainroutes = [
  {
    path: '/ai', name: 'ai', component: () => import('@/ai/AiPage.vue'),
    meta: { title: 'Ai助理', requireAuth: true }
  },
  {
    path: '', ///路由的重定向
    redirect: 'Login'
  },
  {
    path: '/login', ///配置APP默认的入口页面
    name: 'login',
    component: Login
  },
  {
    //隐私政策　ＵＲＬ
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy
  },
  {
    //用户注册服务协议　ＵＲＬ
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    component: ServiceAgreement
  },
  {
    //注册页面
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    //首次登录进入页面
    path: '/firstEntry',
    name: 'firstEntry',
    component: FirstEntry,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //修改密码的页面
    path: '/mchangepassword',
    name: 'mchangepassword',
    component: MChangePassword
  },
  {
    //设置服务器地址页面
    path: '/configServerIP',
    name: 'configServerIP',
    component: configServerIP
  },
  {
    //设置服务器地址页面
    path: '/yanShiPage',
    name: 'yanShiPage',
    component: yanShiPage
  },
  {
    //控制页面
    path: '/controlpage',
    name: 'controlpage',
    component: ControlPage,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    },
    children: [
      ///路由的嵌套
      {
        path: '', ///路由的重定向
        redirect: 'home'
      },
      {
        ////常用页面
        path: 'home',
        name: 'home',
        component: Home,
        meta: {
          title: '常用',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        path: 'region',
        name: 'region',
        component: Region,
        meta: {
          title: '区域',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫

          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        path: 'message',
        name: 'message',
        component: Message,
        meta: {
          title: '消息',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ////修改常用场景
        path: 'HomeChangeScene',
        name: 'HomeChangeScene',
        component: HomeChangeScene,
        meta: {
          title: '修改常用场景', ////这个不用改，改了之后  此页面的title将会隐藏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录token检查的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ////修改常用设备
        path: 'HomeChangeDevice',
        name: 'HomeChangeDevice',
        component: HomeChangeDevice,
        meta: {
          title: '修改常用设备', ////这个不用改，改了之后  此页面的title将会隐藏
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      }
    ]
  },
  {
    //区域管理页面
    path: '/RegionManage',
    name: 'RegionManage',
    component: RegionManage,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //分享管理页面
    path: '/shareManage',
    name: 'shareManage',
    component: shareManage,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //背景管理页面
    path: '/backgroundManage',
    name: 'backgroundManage',
    component: backgroundManage,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    path: '/preferences', name: 'Preferences', component: () => import('@/views/afterLogin/config/preferences.vue'), meta: { requireAuth: true }
  },
  {
    //设置管理主页面
    path: '/ConfigMainPage',
    name: 'ConfigMainPage',
    component: ConfigMainPage,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //设置 场景管理主页面
    path: '/ConfigSceneMain',
    name: 'ConfigSceneMain',
    component: ConfigSceneMain,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    },
    children: [
      ///路由的嵌套
      {
        path: '', ///路由的重定向
        redirect: 'ConfigSceneManage'
      },
      {
        ///场景管理主页面
        path: 'ConfigSceneManage',
        name: 'ConfigSceneManage',
        component: ConfigSceneManage,
        meta: {
          title: '场景管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///添加一个场景页面
        path: 'ConfigAddScene',
        name: 'ConfigAddScene',
        component: ConfigAddScene,
        meta: {
          title: '添加一个场景',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          //代号 20231207-1
          if (to.query.title) {
            store.dispatch('asyUpdataTitle', to.query.title) ///路由传参，修改title
          }
          else {
            store.dispatch('asyUpdataTitle', to.meta.title) ///默认title
          }
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///配置添加修改场景规则列表
        path: 'ConfigAddSceneRule',
        name: 'ConfigAddSceneRule',
        component: ConfigAddSceneRule,
        meta: {
          title: '添加修改场景规则',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///配置选择修改场景规则对象
        path: 'ConfigSelectSceneObject',
        name: 'ConfigSelectSceneObject',
        component: ConfigSelectSceneObject,
        meta: {
          title: '选择修改场景规则对象',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///配置选择场景规则对象区域
        path: 'ConfigSelectSceneObjectRegion',
        name: 'ConfigSelectSceneObjectRegion',
        component: ConfigSelectSceneObjectRegion,
        meta: {
          title: '筛选场景规则对象区域',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      }
    ]
  },
  //代号 20231207-1
  {
    //设置 组管理主页面
    path: '/ConfigGroupMain',
    name: 'ConfigGroupMain',
    component: ConfigGroupMain,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    },
    children: [
      ///路由的嵌套
      {
        path: '', ///路由的重定向
        redirect: 'ConfigGroupManage'
      },
      {
        ///组管理主页面
        path: 'ConfigGroupManage',
        name: 'ConfigGroupManage',
        component: ConfigGroupManage,
        meta: {
          title: '组管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///添加一个组页面
        path: 'ConfigAddGroup',
        name: 'ConfigAddGroup',
        component: ConfigAddGroup,
        meta: {
          title: '添加一个组',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          //代号 20231207-1
          console.log(to.query.title)
          if (to.query.title) {
            store.dispatch('asyUpdataTitle', to.query.title) ///路由传参，修改title
          }
          else {
            store.dispatch('asyUpdataTitle', to.meta.title) ///默认title
          }

          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///配置添加修改组规则列表
        path: 'ConfigAddGroupRule',
        name: 'ConfigAddGroupRule',
        component: ConfigAddGroupRule,
        meta: {
          title: '添加修改组规则',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///配置选择修改组规则对象
        path: 'ConfigSelectGroupObject',
        name: 'ConfigSelectGroupObject',
        component: ConfigSelectGroupObject,
        meta: {
          title: '选择修改组规则对象',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///配置选择组规则对象区域
        path: 'ConfigSelectGroupObjectRegion',
        name: 'ConfigSelectGroupObjectRegion',
        component: ConfigSelectGroupObjectRegion,
        meta: {
          title: '筛选组规则对象区域',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      }
    ]
  },
  {
    //选择区域页面
    path: '/SelectRegion',
    name: 'SelectRegion',
    component: SelectRegion,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //选择icon页面  需要传入图片的类型  0:产品 1:场景 2:设备
    path: '/SelectIcon',
    name: 'SelectIcon',
    component: SelectIcon,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //选择组类型页面   // 代号 20231207-1  组功能实现
    path: '/selectGroupControlType',
    name: 'selectGroupControlType',
    component: selectGroupControlType,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  },
  {
    //设置 账号管理主页面
    path: '/AccountNumberMain',
    name: 'AccountNumberMain',
    component: AccountNumberMain,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    },
    children: [
      ///路由的嵌套
      {
        path: '', ///路由的重定向
        redirect: 'AccountNumberManage'
      },
      {
        ///账号管理主页面
        path: 'AccountNumberManage',
        name: 'AccountNumberManage',
        component: AccountNumberManage,
        meta: {
          title: '账号管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///添加子账号
        path: 'AddSonAccountNumber',
        name: 'AddSonAccountNumber',
        component: AddSonAccountNumber,
        meta: {
          title: '添加子账号',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///控制区域选择
        path: 'SonAccountSelectRegion',
        name: 'SonAccountSelectRegion',
        component: SonAccountSelectRegion,
        meta: {
          title: '控制区域选择',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主账号信息
        path: 'AccountNumberInfoManage',
        name: 'AccountNumberInfoManage',
        component: AccountNumberInfoManage,
        meta: {
          title: '主账号信息',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主账号修改密码
        path: 'ChangePassWord',
        name: 'ChangePassWord',
        component: ChangePassWord,
        meta: {
          title: '主账号修改密码',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///换绑手机号
        path: 'ChangePhoneNumber',
        name: 'ChangePhoneNumber',
        component: ChangePhoneNumber,
        meta: {
          title: '换绑手机号',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///子账号修改密码
        path: 'changeSonPassWord',
        name: 'changeSonPassWord',
        component: changeSonPassWord,
        meta: {
          title: '子账号修改密码',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      }
    ]
  },
  {
    //设置 设备管理主页面
    path: '/DeviceManageMain',
    name: 'DeviceManageMain',
    component: DeviceManageMain,
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    },
    children: [
      ///路由的嵌套
      {
        path: '', ///路由的重定向
        redirect: 'DeviceManage'
      },
      {
        ///设备管理主页面
        path: 'DeviceManage',
        name: 'DeviceManage',
        component: DeviceManage,
        meta: {
          title: '设备管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主机管理-----主机管理
        path: 'hostManage',
        name: 'hostManage',
        component: hostManage,
        meta: {
          title: '主机管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主机管理-----自动搜索主机
        path: 'autoSearchHost',
        name: 'autoSearchHost',
        component: autoSearchHost,
        meta: {
          title: '自动搜索主机',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主机管理-----添加修改主机
        path: 'addChangeHost',
        name: 'addChangeHost',
        component: addChangeHost,
        meta: {
          title: '添加修改主机',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主机管理-----手动添加主机
        path: 'handAddHost',
        name: 'handAddHost',
        component: handAddHost,
        meta: {
          title: '手动添加主机',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///主机管理-----更换主机
        path: 'replaceHost',
        name: 'replaceHost',
        component: replaceHost,
        meta: {
          title: '更换主机',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备上线设置---选择设备主机
        path: 'selectDeviceHost',
        name: 'selectDeviceHost',
        component: selectDeviceHost,
        meta: {
          title: '选择设备主机',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备上线设置---设备上线管理
        path: 'deviceGoOnlineManage',
        name: 'deviceGoOnlineManage',
        component: deviceGoOnlineManage,
        meta: {
          title: '设备上线管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备上线设置---添加新设备
        path: 'addNewDevice',
        name: 'addNewDevice',
        component: addNewDevice,
        meta: {
          title: '',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          if (to.query.type === 'change') {
            console.log(to.query.type)
            to.meta.title = '修改设备信息' ////通过路由传参和路由守卫的方式来决定title
          } else if (to.query.type === 'add') {
            to.meta.title = '添加新设备' ////通过路由传参和路由守卫的方式来决定title
          }
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备上线设置---设备上线管理 // 代号 20241212-1
        path: 'threadDeviceGoOnlineManage',
        name: 'threadDeviceGoOnlineManage',
        component: threadDeviceGoOnlineManage,
        meta: {
          title: '设备上线管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备上线设置---设备上线管理 // 代号 20241212-1
        path: 'threadAddNewDevice',
        name: 'threadAddNewDevice',
        component: threadAddNewDevice,
        meta: {
          title: '设置地址',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          if (to.query.type === 'setGateway') {
            console.log(to.query.type)
            to.meta.title = '设置主机地址' ////通过路由传参和路由守卫的方式来决定title
          } else if (to.query.type === 'add') {
            to.meta.title = '添加新设备' ////通过路由传参和路由守卫的方式来决定title
          }
          else if (to.query.type === 'onLinechangeRemark' || to.query.type === 'offLinechangeRemark') {
            console.log(to.query.type)
            to.meta.title = '修改备注' ////通过路由传参和路由守卫的方式来决定title
          }
          else if (to.query.type === 'onLinechangeAddress' || to.query.type === 'offLinechangeAddress') {
            console.log(to.query.type)
            to.meta.title = '修改地址' ////通过路由传参和路由守卫的方式来决定title
          }
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备上线设置---设备上线管理 // 代号 20241212-1
        path: 'threadNetworkManage',
        name: 'threadNetworkManage',
        component: threadNetworkManage,
        meta: {
          title: '网络管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备上线设置---设备上线管理 // 代号 20241212-1
        path: 'threadNetworkNewStart',
        name: 'threadNetworkNewStart',
        component: threadNetworkNewStart,
        meta: {
          title: '网络管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备上线设置---设备上线管理 // 代号 20241212-1
        path: 'threadDeviceNetIn',
        name: 'threadDeviceNetIn',
        component: threadDeviceNetIn,
        meta: {
          title: '设备入网',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备替换 // 代号 20241212-1
        path: 'threadDeviceReplace',
        name: 'threadDeviceReplace',
        component: threadDeviceReplace,
        meta: {
          title: '设备替换',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备管理  // 代号 20241212-1
        path: 'threadDeviceManage',
        name: 'threadDeviceManage',
        component: threadDeviceManage,
        meta: {
          title: '设备管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread设备管理  // 代号 20241212-1
        path: 'device485Manage',
        name: 'device485Manage',
        component: device485Manage,
        meta: {
          title: '设备管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///面板扩展模块---扩展面板管理
        path: 'panelExtensionManage',
        name: 'panelExtensionManage',
        component: panelExtensionManage,
        meta: {
          title: '扩展面板管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        path: 'productConfigResend',
        name: 'productConfigResend',
        component: productConfigResend,
        meta: { title: '配置数据补发', requireAuth: true },
        beforeEnter: (to, from, next) => {
          store.dispatch('asyUpdataTitle', to.meta.title)
          next()
        }
      },
      {
        path: 'productSceneResend',
        name: 'productSceneResend',
        component: productSceneResend,
        meta: { title: '场景补发', requireAuth: true },
        beforeEnter: (to, from, next) => {
          store.dispatch('asyUpdataTitle', to.meta.title)
          next()
        }
      },
      {
        ///面板扩展模块---添加新面板
        path: 'addThirdPanel',
        name: 'addThirdPanel',
        component: addThirdPanel,
        meta: {
          title: '添加新面板',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///面板扩展模块---设备管理
        path: 'thirdPanelDeviceManage',
        name: 'thirdPanelDeviceManage',
        component: thirdPanelDeviceManage,
        meta: {
          title: '设备管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///面板扩展模块---修改设备信息
        path: 'thirdPanelInfoManage',
        name: 'thirdPanelInfoManage',
        component: thirdPanelInfoManage,
        meta: {
          title: '修改设备信息',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          if (to.query.type === 'onLinechangeRemark' || to.query.type === 'offLinechangeRemark') {
            to.meta.title = '修改备注'
          } else if (to.query.type === 'onLinechangeAddress' || to.query.type === 'offLinechangeAddress') {
            to.meta.title = '修改地址'
          }
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          next() ///必须调用，不然跳转不过去
        }
      },

      {
        ///thread主机管理  // 代号 20241212-1
        path: 'threadGatewayManage',
        name: 'threadGatewayManage',
        component: threadGatewayManage,
        meta: {
          title: '主机管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///thread主机管理  // 代号 20241212-1
        path: 'Gateway485Manage',
        name: 'Gateway485Manage',
        component: Gateway485Manage,
        meta: {
          title: '主机管理',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---设备类型列表
        path: 'deviceTypeList',
        name: 'deviceTypeList',
        component: deviceTypeList,
        meta: {
          title: '设备类型列表',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.meta.title)
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---设备列表
        path: 'deviceList',
        name: 'deviceList',
        component: deviceList,
        meta: {
          title: '设备列表',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---设备详情
        path: 'deviceDetails',
        name: 'deviceDetails',
        component: deviceDetails,
        meta: {
          title: '设备详情',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        //代号20220921-1
        ///设备列表---设备详情
        path: 'configDevice',
        name: 'configDevice',
        component: configDevice,
        meta: {
          title: '配置设备',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        path: 'configDeviceList',
        name: 'configDeviceList',
        component: configDeviceList,
        meta: {
          title: '配置列表',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },

      {
        ///设备列表---设备对象详情
        path: 'deviceObjectDetails',
        name: 'deviceObjectDetails',
        component: deviceObjectDetails,
        meta: {
          title: '设备对象详情',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---选择绑定对象
        path: 'selectBindingObject',
        name: 'selectBindingObject',
        component: selectBindingObject,
        meta: {
          title: '选择绑定对象',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---022定时设备的时间设置页面
        path: 'timeConfig022Page',
        name: 'timeConfig022Page',
        component: timeConfig022Page,
        meta: {
          title: '时间设置',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---022定时设备的定时周期设置页面
        path: 'cycleConfig022Page',
        name: 'cycleConfig022Page',
        component: cycleConfig022Page,
        meta: {
          title: '定时周期设置',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---选择一个场景页面
        path: 'selectOneScene',
        name: 'selectOneScene',
        component: selectOneScene,
        meta: {
          title: '选择一个场景',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          //代号 20231207-1
          console.log(to.query.title)
          if (to.query.title) {
            store.dispatch('asyUpdataTitle', to.query.title) ///路由传参，修改title
          }
          else {
            store.dispatch('asyUpdataTitle', to.meta.title) ///默认title
          }

          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---周期定时任务设置
        path: 'cycleTask027Config',
        name: 'cycleTask027Config',
        component: cycleTask027Config,
        meta: {
          title: '周期定时任务设置',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---添加修改周期定时任务
        path: 'addCycTask027Page',
        name: 'addCycTask027Page',
        component: addCycTask027Page,
        meta: {
          title: '添加修改周期定时任务',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---循环定时任务设置
        path: 'changeLoopTask',
        name: 'changeLoopTask',
        component: changeLoopTask,
        meta: {
          title: '循环定时任务设置',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---选择循环次数
        path: 'selectLoopNum',
        name: 'selectLoopNum',
        component: selectLoopNum,
        meta: {
          title: '选择循环次数',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query)   ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title)////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---选择控制类型
        path: 'select03ControlType',
        name: 'select03ControlType',
        component: select03ControlType,
        meta: {
          title: '',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---选择控制对象
        path: 'select03ControlObject',
        name: 'select03ControlObject',
        component: select03ControlObject,
        meta: {
          title: '',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---019设置参数页面
        path: 'config019Page',
        name: 'config019Page',
        component: config019Page,
        meta: {
          title: '',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---023设置自定义文字
        path: 'config023Page',
        name: 'config023Page',
        component: config023Page,
        meta: {
          title: '修改自定义文字',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---选择控制对象
        path: 'select05ControlObjectState',
        name: 'select05ControlObjectState',
        component: select05ControlObjectState,
        meta: {
          title: '',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      },
      {
        ///设备列表---历史电量统计
        path: 'HistoricalElectricity027Page',
        name: 'HistoricalElectricity027Page',
        component: HistoricalElectricity027Page,
        meta: {
          title: '历史电量统计',
          requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        beforeEnter: (to, from, next) => {
          ///进入该路由前的守卫
          // console.log(to.query) ////通过路由传参和路由守卫的方式来决定title
          // console.log(to.meta.title) ////通过路由传参和路由守卫的方式来决定title
          // to.meta.title = to.query.title ////通过路由传参和路由守卫的方式来决定title
          store.dispatch('asyUpdataTitle', to.meta.title) ///修改title
          // store.dispatch('asyUpdataControlPageType',to.name);  ///切换导航栏的变量值提交
          // console.log(to);
          next() ///必须调用，不然跳转不过去
        }
      }
    ]
  },
  {
    //关于页面
    path: '/aboutPage',
    name: 'aboutPage',
    component: aboutPage,
    meta: {
      // requireAuth: true // 添加该字段，表示进入这个路由是需要登录token认证的
    }
  }

  // {
  //   path: '/mainTabBar', //主页面
  //   name: 'mainTabBar',
  //   component: MainTabBar
  // }
]

export default mainroutes
